import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'soShortStatusTransform',
    standalone: false
})
export class SoShortStatusTransformPipe implements PipeTransform {

    transform(value: string): any {
      if(value === 'T') {
        return 'Tilldelad';
      }  
      if(value === 'P') {
        return 'Pågår';
      }
      if(value === 'O') {
          return 'Öppen';
      }
      if(value === 'Å') {
        return 'Återbesök';
      }
      if(value === 'U') {
          return 'Utförd';
      }
    }
  
  }